"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const TokenStepup_vue_1 = tslib_1.__importDefault(require("../TokenStepup.vue"));
exports.default = vue_1.default.extend({
    name: 'totp',
    props: {
        stepUpCategory: {
            type: Object,
            required: true,
        },
    },
    computed: {},
    methods: {},
    components: {
        TokenStepup: TokenStepup_vue_1.default,
    },
});
